module.exports = __webpack_public_path__ + "static/media/RoofProblem.8dbef820.jpg";